import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import {
  Page,
  Card,
  Button,
  Pagination,
  Box,
} from '../components';
import {
  getUserDetails,
  getCarrier,
  getClient,
} from '../modules/selectors';
import api from '../utils/services';

const propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      carrierId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  user: PropTypes.shape({
    agentNpn: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    userRole: PropTypes.string,
  }),
  carrier: PropTypes.shape({
    carrierId: PropTypes.number,
    carrierName: PropTypes.string,
  }),
  client: PropTypes.shape({
    clientName: PropTypes.string,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object,
};
const defaultProps = {
  carrier: null,
  user: null,
  theme: undefined,
};

function StaticFiles({
  carrier, match, user, client,
}) {
  const Image = styled.img(() => ({
    height: '110px',
    width: '300px',
  }));

  const Container = styled.div`
    display: flex;
    padding: 10px 0px;
    border: 1px solid ${props => props.theme.borderColor};
    gap: 15px;
    align-items: center;
`;

  const copyUrlText = 'Copy Url';
  // eslint-disable-next-line no-undef
  const cdnPath = CDN_URL;
  const totalFilesPerPage = 6;
  const [fileNames, setFileNames] = useState([]);
  const [currentPageFileNames, setCurrentPageFileNames] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [urlCopyText, setUrlCopyText] = useState(copyUrlText);

  useEffect(() => {
    api.fetchFileNames(client.clientName, carrier.carrierId)
      .then((response) => {
        setFileNames(response);
        setTotalCount(response.length);
        const offset = (currentPage - 1) * totalFilesPerPage;
        setCurrentPageFileNames(response.slice(offset, offset + totalFilesPerPage));
        setLoading(false);
      });
  }, [fileNames.length]);


  const handleCopyUrl = (copyText) => {
    if (copyText && copyText.length > 0) {
      navigator.clipboard.writeText(copyText);
      setUrlCopyText('Url copied!');
      setTimeout(() => {
        setUrlCopyText(copyUrlText);
      }, 1000);
    }
  };

  const handlePageChange = (current) => {
    const offset = (current - 1) * totalFilesPerPage;
    setCurrentPageFileNames(fileNames.slice(offset, offset + totalFilesPerPage));
    setCurrentPage(current);
  };

  const imagesDiv = currentPageFileNames.map((filename) => {
    const path = `${cdnPath}${filename.key}`;
    return (
      <Container key={filename.key}>
        <Image src={path} alt="Banner" />
        <code>{ path }</code>
        <Button onClick={() => handleCopyUrl(path)}>{urlCopyText}</Button>
      </Container>
    );
  });

  const paginationMarkup = (totalCount > totalFilesPerPage) ? (
    <Box margin="1em">
      <Pagination
        currentPage={currentPage}
        onPageChange={handlePageChange}
        pageSize={totalFilesPerPage}
        totalCount={totalCount}
      />
    </Box>
  ) : null;

  return (
    <Page
      title="Images"
      subtitle="Files are static and same across the environment"
      primaryAction={user ? { content: 'Add Image', href: `${match.url}/new` } : undefined}
      variableWidth={90}
    >
      {paginationMarkup}
      <Card loading={loading}>
        {imagesDiv}
      </Card>
      {paginationMarkup}
    </Page>
  );
}

function mapStateToProps(state) {
  return {
    user: getUserDetails(state),
    carrier: getCarrier(state),
    client: getClient(state),
  };
}

StaticFiles.propTypes = propTypes;
StaticFiles.defaultProps = defaultProps;
export default connect(mapStateToProps)(StaticFiles);
